/* Phase 2: native controls, scoped state and existing-content containment. */
(function () {
  'use strict';
  var sequence = 0;
  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setDisclosure(button, panel, open) {
    button.setAttribute('aria-expanded', String(open));
    button.classList.toggle('active', open);
    button.classList.toggle('expanded', open);
    panel.hidden = !open;
  }

  function initDisclosures(scope) {
    scope.querySelectorAll('[data-dio-disclosure]').forEach(function (button) {
      if (button.dataset.dioReady) return;
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;
      button.dataset.dioReady = 'true';
      setDisclosure(button, panel, false);
      button.addEventListener('click', function () {
        var open = button.getAttribute('aria-expanded') !== 'true';
        if (open && button.hasAttribute('data-dio-exclusive')) {
          button.closest('.accordion-view').querySelectorAll('[data-dio-exclusive]').forEach(function (other) {
            if (other === button) return;
            var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
            if (otherPanel) setDisclosure(other, otherPanel, false);
          });
        }
        setDisclosure(button, panel, open);
        if (open) refreshInstructionCarousels(panel);
      });
    });
  }

  function initProductPanels(scope) {
    scope.querySelectorAll('[data-dio-product-panels]').forEach(function (root) {
      if (root.dataset.dioReady) return;
      root.dataset.dioReady = 'true';
      var tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      var desktop = root.querySelector('.desktop-view');
      function select(tab, focus) {
        tabs.forEach(function (other) {
          var current = tab === other;
          other.setAttribute('aria-selected', String(current));
          other.tabIndex = current ? 0 : -1;
          other.classList.toggle('active', current);
          var panel = document.getElementById(other.getAttribute('aria-controls'));
          if (panel) panel.hidden = !current;
        });
        if (focus) tab.focus();
        refreshInstructionCarousels(root);
      }
      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (event) {
          var next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          select(tabs[next], true);
        });
      });
      if (tabs.length) select(tabs[0], false);
      // Preserve the existing feature-card expansion without hijacking links
      // in their descriptions. Prefix duplicated page-body IDs per instance.
      root.querySelectorAll('ul.tabs-content > li').forEach(function (card) {
        var panel = card.querySelector('.accordion-contents');
        if (!panel) return;
        var header = document.createElement('div');
        header.className = 'tabs-content-item-header';
        while (card.firstChild && card.firstChild !== panel) header.appendChild(card.firstChild);
        card.insertBefore(header, panel);
        panel.id = 'dio-feature-detail-' + (++sequence);
        header.setAttribute('role', 'button');
        header.tabIndex = 0;
        header.setAttribute('aria-controls', panel.id);
        header.setAttribute('aria-expanded', 'false');
        header.querySelectorAll('a').forEach(function (link) {
          link.removeAttribute('href');
          link.setAttribute('role', 'presentation');
          link.tabIndex = -1;
        });
        header.querySelectorAll('svg').forEach(function (svg) { svg.setAttribute('aria-hidden', 'true'); });
        panel.hidden = true;
        function activate() {
          var open = header.getAttribute('aria-expanded') !== 'true';
          root.querySelectorAll('.tabs-content-item-header').forEach(function (other) {
            if (other === header) return;
            other.setAttribute('aria-expanded', 'false');
            other.parentElement.classList.remove('show');
            other.nextElementSibling.hidden = true;
          });
          header.setAttribute('aria-expanded', String(open));
          card.classList.toggle('show', open);
          panel.hidden = !open;
        }
        header.addEventListener('click', activate);
        header.addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          activate();
        });
      });
      // When a viewport change hides the focused presentation, return focus to
      // its equivalent control in the newly visible presentation.
      var breakpoint = window.matchMedia('(max-width: 749px)');
      breakpoint.addEventListener('change', function (event) {
        var active = document.activeElement;
        if (!root.contains(active)) return;
        var mobile = root.querySelector('.mobile-only');
        if (event.matches && desktop.contains(active)) {
          var selected = tabs.findIndex(function (tab) { return tab.getAttribute('aria-selected') === 'true'; });
          var button = mobile.querySelectorAll('[data-dio-disclosure]')[Math.max(0, selected)];
          if (button) button.focus();
        } else if (!event.matches && mobile.contains(active)) {
          var current = tabs.find(function (tab) { return tab.getAttribute('aria-selected') === 'true'; });
          if (current) current.focus();
        }
        refreshInstructionCarousels(root);
      });
    });
  }

  function refreshInstructionCarousels(scope) {
    if (!window.jQuery || !window.jQuery.fn.owlCarousel) return;
    scope.querySelectorAll('[data-dio-instruction-carousel]').forEach(function (carousel) {
      if (!carousel.classList.contains('owl-carousel')) return;
      var $carousel = window.jQuery(carousel);
      function labelDots() {
        var dots = Array.from(carousel.querySelectorAll('.owl-dot')).filter(function (button) {
          return button.closest('.owl-carousel') === carousel;
        });
        dots.forEach(function (button, index) {
          var label = carousel.dataset.instructionDotLabel || 'Show instruction group __number__ of __total__';
          button.type = 'button';
          button.setAttribute('aria-label', label.replace('__number__', String(index + 1)).replace('__total__', String(dots.length)));
          button.tabIndex = 0;
          if (button.classList.contains('active')) button.setAttribute('aria-current', 'step');
          else button.removeAttribute('aria-current');
        });
        carousel.querySelectorAll('.owl-item').forEach(function (item) {
          item.setAttribute('aria-hidden', String(!item.classList.contains('active')));
        });
      }
      if (!carousel.dataset.dioDotsReady) {
        carousel.dataset.dioDotsReady = 'true';
        $carousel.on('initialized.owl.carousel changed.owl.carousel refreshed.owl.carousel translated.owl.carousel', labelDots);
        carousel.addEventListener('click', function () { queueMicrotask(labelDots); });
      }
      if (!$carousel.hasClass('owl-loaded')) {
        var single = carousel.dataset.instructionItems === '1';
        $carousel.owlCarousel({loop:false, nav:false, dots:true, responsive:{0:{items:1},600:{items:single ? 1 : 2},1000:{items:single ? 1 : 2},1200:{items:single ? 1 : 4}}});
      } else $carousel.trigger('refresh.owl.carousel');
      labelDots();
    });
  }

  function initStepCarousel(carousel) {
    if (carousel.dataset.dioReady) return;
    carousel.dataset.dioReady = 'true';
    var steps = Array.from(carousel.children);
    if (!steps.length) return;
    var current = 0;
    var controls = document.createElement('div');
    controls.className = 'dio-step-dots';
    controls.setAttribute('role', 'group');
    controls.setAttribute('aria-label', 'Instruction slides');
    var status = document.createElement('span');
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    var dots = steps.map(function (step, index) {
      step.id = 'dio-instruction-step-' + (++sequence);
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', 'Show instruction step ' + (index + 1) + ' of ' + steps.length);
      dot.setAttribute('aria-controls', step.id);
      dot.addEventListener('click', function () { show(index); });
      controls.append(dot);
      return dot;
    });
    carousel.append(controls, status);
    function show(index) {
      if (index < 0 || index >= steps.length) return;
      current = index;
      steps.forEach(function (step, position) { step.hidden = position !== current; });
      status.textContent = 'Step ' + (current + 1) + ' of ' + steps.length;
      dots.forEach(function (dot, position) {
        if (position === current) dot.setAttribute('aria-current', 'step');
        else dot.removeAttribute('aria-current');
      });
    }
    controls.addEventListener('keydown', function (event) {
      var index;
      if (event.key === 'ArrowLeft') index = (current + steps.length - 1) % steps.length;
      if (event.key === 'ArrowRight') index = (current + 1) % steps.length;
      if (event.key === 'Home') index = 0;
      if (event.key === 'End') index = steps.length - 1;
      if (index === undefined) return;
      event.preventDefault();
      show(index);
      dots[index].focus();
    });
    var touchStart;
    carousel.addEventListener('touchstart', function (event) { touchStart = event.changedTouches[0].clientX; }, {passive:true});
    carousel.addEventListener('touchend', function (event) {
      if (touchStart === undefined) return;
      var distance = event.changedTouches[0].clientX - touchStart;
      if (Math.abs(distance) > 50) show(current + (distance < 0 ? 1 : -1));
      touchStart = undefined;
    }, {passive:true});
    show(0);
  }

  function initDialogs(scope) {
    scope.querySelectorAll('.dio-instructions-dialog').forEach(function (dialog) {
      if (dialog.dataset.dioReady) return;
      dialog.dataset.dioReady = 'true';
      var opener;
      function closeDialog() {
        dialog.close();
        document.documentElement.classList.remove('dio-dialog-open');
        if (opener && opener.isConnected) opener.focus();
      }
      dialog.querySelectorAll('.popup-content').forEach(function (group) {
        if (group.querySelectorAll('.title-image').length === 2) group.classList.add('dio-paired-instructions');
      });
      dialog.querySelectorAll('[data-dio-step-carousel]').forEach(initStepCarousel);
      dialog.querySelectorAll('[data-dio-local-disclosure]').forEach(function (button) {
        var panel = button.nextElementSibling;
        panel.id = 'dio-dialog-panel-' + (++sequence);
        button.setAttribute('aria-controls', panel.id);
        setDisclosure(button, panel, false);
        button.addEventListener('click', function () { setDisclosure(button, panel, button.getAttribute('aria-expanded') !== 'true'); });
      });
      scope.querySelectorAll('[data-dio-dialog-open]').forEach(function (button) {
        if (button.getAttribute('data-dio-dialog-open') !== dialog.id) return;
        button.addEventListener('click', function () {
          opener = button;
          dialog.showModal();
          document.documentElement.classList.add('dio-dialog-open');
          dialog.querySelector('[data-dio-dialog-close]').focus();
        });
      });
      dialog.querySelector('[data-dio-dialog-close]').addEventListener('click', closeDialog);
      dialog.addEventListener('cancel', function (event) {
        event.preventDefault();
        closeDialog();
      });
      dialog.addEventListener('keydown', function (event) {
        if (event.key !== 'Tab') return;
        var focusable = Array.from(dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex="0"]')).filter(function (element) {
          return element.getClientRects().length && !element.closest('[hidden]');
        });
        if (!focusable.length) return;
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      dialog.addEventListener('click', function (event) {
        if (event.target !== dialog) return;
        var rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog();
      });
      dialog.addEventListener('close', function () {
        // Native close events are queued; an older dialog must not steal focus
        // back from a new opener or remove the new dialog's scroll lock.
        if (!document.querySelector('.dio-instructions-dialog[open]')) {
          document.documentElement.classList.remove('dio-dialog-open');
          if (dialog.contains(document.activeElement) && opener && opener.isConnected) opener.focus();
        }
      });
    });
  }

  function initHeroVideos(scope) {
    scope.querySelectorAll('[data-dio-hero-video]').forEach(function (container) {
      if (container.dataset.dioReady) return;
      container.dataset.dioReady = 'true';
      var video = container.querySelector('video');
      if (!video) {
        container.classList.add('video-loaded');
        return;
      }
      video.id = 'dio-hero-video-' + (++sequence);
      video.removeAttribute('autoplay');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'dio-video-toggle';
      button.setAttribute('aria-controls', video.id);
      container.append(button);
      video.controls = false;
      function state() {
        button.textContent = video.paused ? 'Play video' : 'Pause video';
        button.setAttribute('aria-label', video.paused ? 'Play introductory video' : 'Pause introductory video');
        button.title = button.getAttribute('aria-label');
        button.dataset.dioPaused = String(video.paused);
      }
      function play() {
        var promise = video.play();
        if (promise) promise.catch(function () { state(); });
      }
      button.addEventListener('click', function () { if (video.paused) play(); else video.pause(); });
      ['play', 'pause', 'ended'].forEach(function (event) { video.addEventListener(event, state); });
      video.addEventListener('loadeddata', function () { container.classList.add('video-loaded'); });
      video.addEventListener('playing', function () { container.classList.add('video-loaded'); });
      if (video.readyState >= 2) container.classList.add('video-loaded');
      motionQuery.addEventListener('change', function (event) { if (event.matches) video.pause(); });
      if (container.dataset.autoplay === 'true' && !motionQuery.matches) play();
      else video.pause();
      state();
    });
  }

  function bindCarousel($slider, $dots, configuredAutoplay, label) {
    if ($slider.attr('data-dio-motion-ready')) return;
    $slider.attr('data-dio-motion-ready', 'true');
    $slider.attr({'role':'region', 'aria-roledescription':'carousel', 'aria-label':label});
    var region = $dots.parent();
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'dio-motion-toggle';
    var controls = document.createElement('div');
    controls.className = 'dio-carousel-motion-row';
    if ($dots.hasClass('customer-reviews-dots')) controls.classList.add('dio-review-motion-row');
    $dots.before(controls);
    controls.append($dots[0], button);
    var paused = !configuredAutoplay || motionQuery.matches;
    function setPaused(value) {
      paused = value;
      $slider.slick(paused ? 'slickPause' : 'slickPlay');
      button.textContent = (paused ? 'Play ' : 'Pause ') + label;
      button.setAttribute('aria-label', (paused ? 'Start automatic ' : 'Pause automatic ') + label);
      button.dataset.dioPaused = String(paused);
      $slider.attr('data-dio-motion-paused', String(paused));
      $slider.attr('aria-live', paused ? 'polite' : 'off');
    }
    button.addEventListener('click', function () { setPaused(!paused); });
    region.on('focusin', function (event) { if (event.target !== button && !paused) setPaused(true); });
    var configuredSpeed = $slider.slick('slickGetOption', 'speed');
    motionQuery.addEventListener('change', function (event) {
      $slider.slick('slickSetOption', 'speed', event.matches ? 0 : configuredSpeed, false);
      if (event.matches) setPaused(true);
    });
    if (motionQuery.matches) $slider.slick('slickSetOption', 'speed', 0, false);
    setPaused(paused);
  }

  function initTables(scope) {
    scope.querySelectorAll('.product__description table, .article-template__content table').forEach(function (table) {
      if (table.closest('.dio-table-scroll')) return;
      var wrapper = document.createElement('div');
      wrapper.className = 'dio-table-scroll';
      var caption = table.querySelector('caption');
      var product = table.closest('.product__description');
      wrapper.setAttribute('role', 'region');
      wrapper.setAttribute('aria-label', (caption ? caption.textContent.trim() : product ? 'Product information table' : 'Article comparison table') + ' — scroll horizontally when needed');
      table.parentElement.insertBefore(wrapper, table);
      wrapper.append(table);
      var firstRow = table.querySelector('tr');
      if (firstRow) firstRow.querySelectorAll('th').forEach(function (cell) { if (!cell.hasAttribute('scope')) cell.setAttribute('scope', 'col'); });
      table.querySelectorAll('tr').forEach(function (row) {
        var first = row.firstElementChild;
        if (!first || first.tagName !== 'TD' || first.querySelector('a,button,input') || row.querySelectorAll('td').length < 2) return;
        // First-column measurements/feature names label these content rows.
        if (!first.textContent.trim()) return;
        var header = document.createElement('th');
        Array.from(first.attributes).forEach(function (attr) { header.setAttribute(attr.name, attr.value); });
        header.setAttribute('scope', 'row');
        while (first.firstChild) header.append(first.firstChild);
        header.style.fontWeight = 'inherit';
        header.style.textAlign = 'inherit';
        first.replaceWith(header);
      });
      function focusability() { wrapper.tabIndex = wrapper.scrollWidth > wrapper.clientWidth + 1 ? 0 : -1; }
      wrapper.addEventListener('keydown', function (event) {
        if (event.target !== wrapper) return;
        var left;
        if (event.key === 'ArrowRight') left = wrapper.scrollLeft + 80;
        if (event.key === 'ArrowLeft') left = wrapper.scrollLeft - 80;
        if (event.key === 'Home') left = 0;
        if (event.key === 'End') left = wrapper.scrollWidth;
        if (left === undefined) return;
        event.preventDefault();
        wrapper.scrollLeft = left;
      });
      focusability();
      if (window.ResizeObserver) new ResizeObserver(focusability).observe(wrapper);
    });
  }

  function initNestedVideoVisibility(scope) {
    scope.querySelectorAll('.collapse-tab-eecol').forEach(function (section) {
      if (section.dataset.dioVideoVisibilityReady) return;
      section.dataset.dioVideoVisibilityReady = 'true';
      var videos = Array.from(section.querySelectorAll('[data-button-video-root] video'));
      function pauseHidden() {
        videos.forEach(function (video) {
          if (!video.paused && !video.getClientRects().length) video.pause();
        });
      }
      videos.forEach(function (video) { video.addEventListener('play', pauseHidden); });
      new MutationObserver(pauseHidden).observe(section, {
        subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden']
      });
      pauseHidden();
    });
  }

  function init(scope) {
    initDisclosures(scope);
    initProductPanels(scope);
    initDialogs(scope);
    initHeroVideos(scope);
    initNestedVideoVisibility(scope);
    initTables(scope);
    refreshInstructionCarousels(scope);
  }
  window.DioPhaseTwo = {bindCarousel:bindCarousel};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
